import { render, staticRenderFns } from "./BarExample.vue?vue&type=template&id=372224fd&"
import script from "./BarExample.vue?vue&type=script&lang=js&"
export * from "./BarExample.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports